export default __webpack_public_path__ + "static/media/hmd_s2.59be4edd.png";